//@ts-check
(function() {

    function checkCookie(cookieName, value) { 
        var cookieExistsWithValue = 
            document.cookie.split(';') // Array of all cookies
            .filter( function(item) { 
                return item.indexOf(cookieName + '=' + value) >= 0; }
            ) // Array of all cookies that are cookieName + '=' + value
            .length > 0; // Count of all cookies that are cookieName + '=' + value
        
        return cookieExistsWithValue;
    }

    function prefersReducedMotion(){
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || checkCookie('prefers-reduced-motion', 'reduce')) {
            // Handle JavaScript differently
            return true;
        }
        return false;
    }

    var Player = {
        waitingForUser : true,
        isExpectingPlay : false,
        isReady : false,
        firstPlay : true,
        playerVars : {
            rel: 0,
            controls : 0,
            autoplay : 0,
            iv_load_policy : 1,
            enablejsapi : 1
        },
        hasPlayerBeenCreated : false,
        detailProgress : 0,
        bufferProgress : 0,
        detailProgressMonitor : 0,
        wrapper : null,
        player : null,
        videoProgress : null,
        videoBufferedInner : null,
        videoProgressInner : null,
        fullscreenIcon : null,
        inProgress : false,
        playing : false,
        autoplay: false,
        loop : false,
        muted : false,
        playOnHover : false,
        videoSource : null,
        iconText : null,
        playPromise : null,
        isFirstPlay : true,

        togglePlayback : function(event) {

            if ( this.waitingForUser && this.type != "media" ){
              this.waitingForUser = false;
              this.isExpectingPlay = true;
            } else {
              if ( this.type === "youtube" ) {
                if ( this.player.getPlayerState() === 1 ){
                    if(prefersReducedMotion()){
                        this.pauseVideo();
                    }
                } else {
                  this.playVideo();
                }
          
              } else {
          
                if ( !this.player.paused ){
                    if(prefersReducedMotion()){
                        this.pauseVideo();
                    }
                  alert('pause');
                } else {
                  this.playVideo();
                }
              }
            }
        },
        checkVideoPlayingStatus : function() {
            var videoPlayerState = this.player.getPlayerState();
            if ( videoPlayerState == -1 || videoPlayerState == 5 || videoPlayerState == 3 ) {
                this.isCheckingPlayingStatus = true;
                this.playVideo();
                setTimeout(function() {
                    this.isCheckingPlayingStatus = false;
                    this.checkVideoPlayingStatus();
                }.bind(this), 3000);
            }
        },
        playVideo : function() {

            if ( !this.isReady ) {
                // console.log("Tried to play before player was ready.");
                this.isExpectingPlay = true;
            } else {
                // console.log("Playing video.", this.type, this.videoSource);
                if ( this.hasPlayerBeenCreated ) {
                    if ( this.type == "youtube" ) {
                        this.player.playVideo();
                    } else {
                        if ( !this.autoplay || !this.muted ) {
                            this.player.volume = 0.5;
                        }
                        this.playPromise = this.player.play();
                        if ( this.playPromise !== undefined || this.playPromise !== null ) {
                            this.playPromise = new Promise(function(resolve, reject) {
                                resolve();
                            }.bind(this));
                        } 
                        this.playPromise.then(function(res) {
                            this.playPromiseIsResolved = true;
                        }.bind(this));
                    }
                    this.wrapper.parentNode.classList.add('activated');
                    this.wrapper.parentNode.classList.remove('paused');
    
                    if(!this.firstPlay){
                        this.wrapper.parentNode.classList.remove('ended');
                    }
                }
    
                if ( this.autoplay == true && this.type == "youtube" && !this.isCheckingPlayingStatus ) {
                    this.checkVideoPlayingStatus();
                }

            }
        },
        pauseVideo : function() {
            // console.log("Pausing video.", this.type, this.videoSource);
            if ( this.hasPlayerBeenCreated ) {
                this.updateProgress(0.5);
                if ( this.type == "youtube" ) {
                    this.player.pauseVideo();
                    // console.log("Pausing youtube video. Hopefully");
                } else {
                    if ( this.player.paused !== true ) {
                        this.playPromise.then(function(res) {
                            this.player.pause();
                        }.bind(this));
                    }
                }
                this.wrapper.parentNode.classList.remove('playing');
                this.wrapper.parentNode.classList.add('paused');
            }
        },
        unmuteVideo: function () {
          if (this.hasPlayerBeenCreated) {
              if (this.type === "youtube") {
                  this.player.unMute();
              } else {
                  this.player.muted = false;
              }
              this.muted = false;
          }
        },
        muteVideo: function () {
          if (this.hasPlayerBeenCreated) {
            if (this.type === "youtube") {
              this.player.mute();
            } else {
              this.player.muted = true;
            }
            this.muted = true;
          }
        },
        seekVideo : function(event) {
            var seekPct = event.offsetX / this.wrapper.querySelector('.videoProgressOuter').offsetWidth;
            if ( this.type === "youtube" ) {
              this.player.seekTo(seekPct * this.player.getDuration(),true);
            } else {
              this.player.currentTime = seekPct * this.player.duration;
            }
            this.detailProgress = seekPct * 100;
        },
        updateProgress : function(offset) {
            if ( this.type === "youtube" ) {
                this.detailProgress = ((this.player.getCurrentTime() + offset) / this.player.getDuration()) * 100;
                this.bufferProgress = this.player.getVideoLoadedFraction() * 100;
            } else {
                this.detailProgress = (this.player.currentTime / this.player.duration) * 100;
                this.bufferProgress = this.player.buffered.length > 0 ? (this.player.buffered.end(0) / this.player.duration) * 100 : 0;
            }
            this.videoBufferedInner.style.width = this.bufferProgress + "%";
            this.videoProgressInner.style.width = this.detailProgress + "%";
        },
        readyHandler : function(event) {
            // console.log("Ready handler fired.");
            this.isReady = true;
            this.inProgress = false;
          
            if ( this.firstPlay ){
              this.firstPlay = false;
            }

            if ( this.isExpectingPlay == true ) {
                this.playVideo();
            }
            if ( this.muted && this.type == "youtube" ) {
                this.player.mute();
            }
        },
        playingHandler : function(event) {
            this.inProgress = true;
            this.playing = true;
            //start progress monitor
            if ( this.detailProgressMonitor !== null ){
              this.detailProgress = 0;
              this.bufferProgress = 0;
          
              this.updateProgress(0.5);
              
              clearInterval(this.detailProgressMonitor);
            }

            if ( this.isFirstPlay ) {
                this.wrapper.parentNode.classList.add('first-play');
                this.isFirstPlay = false;
            } 
          
            this.updateProgress(0.5);
            this.detailProgressMonitor = setInterval(function(){
              this.updateProgress(0.5);
            }.bind(this), 500);

            this.wrapper.parentNode.classList.add('playing');
            this.wrapper.parentNode.classList.remove('paused');
          
        },
        pausedHandler : function(event) { 

            this.inProgress = true;
            this.playing = false;
            this.updateProgress(0);
            //stop progress monitor
            if ( this.detailProgressMonitor !== null ){
                clearInterval(this.detailProgressMonitor);
            }

            if ( this.playing ) {
                // console.log('video is in progress');
            }

            if ( !this.playing && this.iconText != null ) {
                this.iconText.textContent = "Continue Video"
                // console.log('video is paused');
            }
            
            // TODO: ADD VIDEO COVER ON PAUSED

            this.wrapper.parentNode.classList.add('paused');
        },
        endedHandler : function(event) {
            // TODO: Add/Verify ended video class on entire video
            
            this.inProgress = false;
            this.playing = false;
            if ( this.loop ) {
                this.player.playVideo();
            } else {
                this.wrapper.parentNode.classList.remove('activated');
                this.wrapper.parentNode.classList.add('ended');
                this.iconText.textContent = "Replay Video"
                // console.log('video has ended');
            }
        },
        handleStateChange: function(event) {
            switch (event.data) {
                case 0:
                    this.endedHandler(event);
                    break;

                case 1:
                    this.playingHandler(event);
                    break;
            
                case 2:
                    this.pausedHandler(event);
                    break;

                default:
                    break;
            }
        },
        addEventListeners : function() {
            if ( this.prmPlayButton != null ) {
                this.prmPlayButton.addEventListener('click', function(event) {
                    this.handleButtonClick(event);
                }.bind(this));
            }

            this.wrapper.querySelector('.play-icon').addEventListener('click', function(event) {
                this.handleButtonClick(event);
            }.bind(this));

            this.wrapper.querySelector('.videoProgressOuter').addEventListener('click', function(event) {
                this.seekVideo(event);
            }.bind(this))

            this.fullscreenIcon.addEventListener('click', this.handleFullscreen.bind(this));

             // Get the unmute button element within the current player's wrapper
            var unmuteButton = this.wrapper.querySelector('.js-unmute');
            var muteButton = this.wrapper.querySelector('.js-mute');

            if(unmuteButton) {
              // Attach a click event listener to the unmute button
              unmuteButton.addEventListener('click', function () {
                  this.unmuteVideo();

                  // Hide the unmute button and show the mute button
                  unmuteButton.classList.add('hidden');
                  muteButton.classList.remove('hidden');
              }.bind(this));
            } 

            if(muteButton) {
              // Attach a click event listener to the unmute button
              muteButton.addEventListener('click', function () {
                  this.muteVideo();

                  // Hide the unmute button and show the mute button
                  muteButton.classList.add('hidden');
                  unmuteButton.classList.remove('hidden');
              }.bind(this));
            } 
            

        },

       

        handleButtonClick : function(event) {
            this.isExpectingPlay = true;
            if ( this.hasPlayerBeenCreated ) {
                this.togglePlayback();
            } else {
                this.createPlayer();
            }
        },

        handleFullscreen : function() {
            this.wrapper.requestFullscreen();
        },

        handlePlayerReady : function() {
            if ( !this.isReady ) {
        
                this.player.addEventListener('ready', function(event) {
                    this.readyHandler(event);
                }.bind(this));
                this.player.addEventListener('playing', function(event) {
                    this.playingHandler(event);
                }.bind(this));
                this.player.addEventListener('paused', function(event) {
                    this.pausedHandler(event);
                }.bind(this));
                this.player.addEventListener('ended', function(event) {
                    this.endedHandler(event);
                }.bind(this));

                this.player.src = this.videoSource;

                this.readyHandler();
            }
        },
        createPlayer : function() {
            // this.isExpectingPlay = true;
            this.waitingForUser = false;
            this.hasPlayerBeenCreated = true;

            this.wrapper.parentNode.classList.add('activated');

            if ( this.type == "youtube" ) {
                var playerVars = {};
                if ( this.autoplay) {
                    playerVars.autoplay = 1;
                }
                if ( this.loop ) {
                    playerVars.loop = 1;
                }
    
                playerVars = Object.assign({}, this.playerVars, playerVars);
                var player;
                player = new window.YT.Player(this.player.id, {
                  videoId: this.player.getAttribute('data-video-id'),
                  playerVars: playerVars,
                  events: {
                    'onReady': function(event) { this.readyHandler(event) }.bind(this),
                    'onStateChange': function(event) { this.handleStateChange(event) }.bind(this),
                  },
                  host : "https://www.youtube.com"
                });
                this.player = player;
                this.player.f.tabIndex = -1;
            } else {
                var player = document.createElement('video');
                this.videoSource = this.player.getAttribute('data-video-src');
                if ( this.player.hasAttribute('data-video-poster') ) {
                    player.setAttribute('poster', this.player.getAttribute('data-video-poster'));
                }
                var _self = this;
                player.onclick = function() {
                    this.paused ? _self.playVideo() : _self.pauseVideo();
                }
                if ( this.autoplay && !prefersReducedMotion()) {
                    // player.autoplay = true;
                    player.setAttribute('playsinline', '');
                    player.setAttribute('muted', 'true');
                    player.muted = true;
                } 
                if ( this.loop ) {
                    player.loop = true;
                }
                if ( this.muted ) {
                    player.muted = true;
                }
                this.wrapper.replaceChild(player, this.player);
                this.player = player;

                if ( !this.autoplay ) {
                    this.handlePlayerReady();
                }

                if ( this.playOnHover ) {
                    this.wrapper.addEventListener('mouseover', function() {
                        this.playVideo();
                    }.bind(this))
                    this.player.addEventListener('mouseleave', function() {
                        this.pauseVideo();
                    }.bind(this))
                }
            }
        },

        init : function(type, playerElement, playerWrapper) {
            this.type = type;
            this.wrapper = playerWrapper;
            this.player = playerElement;
            this.playerWrapperId = playerWrapper.id;
            this.videoProgress = this.wrapper.querySelector('.videoProgressOuter');
            this.videoBufferedInner = this.wrapper.querySelector('.videoBufferedInner');
            this.videoProgressInner = this.wrapper.querySelector('.videoProgressInner');
            this.fullscreenIcon = this.wrapper.querySelector('.fullscreen-icon');
            this.prmPlayButton = this.wrapper.querySelector('.prm-video-play-button');
            this.endedVC = document.querySelector('.video_ended-video-cover');
            this.iconText = document.querySelector('.icon-text');
            
            this.addEventListeners();
            if ( this.player.hasAttribute('data-video-autoplay') && !prefersReducedMotion()) {
                this.autoplay = true;
            }
            if ( this.player.hasAttribute('data-video-loop') ) {
                this.loop = true;
            }
            if ( this.player.hasAttribute('data-video-muted') ) {
                this.muted = true;
            }
            if ( this.player.hasAttribute('data-video-play-on-hover') ) {
                this.playOnHover = true;
            }
            if ( this.autoplay && !prefersReducedMotion() ) {
                this.createPlayer();
            }
        }
    };

    var video = {
        PLAYER_WRAPPER_SELECTOR : ".video-player-wrapper",
        PLAYER_SELECTOR : ".player",
        players : [],
        playersNeedingLoad : {},
        playersNeedingPlay : {},
        imagesAreLoaded : false,
        loadYoutubeApi : function() {
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = function() {
                this.hasLoadedYoutubeApi = true;
                this.initializePlayers();
            }.bind(this);
        },
        hasLoadedYoutubeApi : false,
        initializePlayers : function() {
            var playerWrappers = document.querySelectorAll(this.PLAYER_WRAPPER_SELECTOR);
            for ( var i = 0; i < playerWrappers.length; i++ ) {
                var playerWrapper = playerWrappers[i];
                var playerElement = playerWrapper.querySelector(this.PLAYER_SELECTOR);
                
                if(playerElement) {
                  var type = playerElement.hasAttribute('data-video-id') ? "youtube" : "video";
                  var player = Object.assign({}, Player);
                  player.init(type, playerElement, playerWrapper);
                  this.players.push(player);
                  if ( this.playersNeedingLoad[playerWrapper.id] && type != "youtube" ) {
                      player.handlePlayerReady();
                  }
                  if ( this.playersNeedingPlay[playerWrapper.id] && type != "youtube" ) {
                      player.playVideo();
                  }
                }
            }
        },
        loadPlayer : function(playerWrapper) {
            if ( this.players.length == 0 ) {
                this.playersNeedingLoad[playerWrapper.id] = true;
            };
            for ( var i = 0; i < this.players.length; i++ ) {
                var currentPlayer = this.players[i];
                if ( playerWrapper.id == currentPlayer.playerWrapperId ) {
                    currentPlayer.handlePlayerReady();
                }
            }
        },
        playPlayer : function(playerWrapper) {
            if ( this.players.length == 0 ) {
                this.playersNeedingPlay[playerWrapper.id] = true;
            };
            for ( var i = 0; i < this.players.length; i++ ) {
                var currentPlayer = this.players[i];
                if ( playerWrapper.id == currentPlayer.playerWrapperId && ( !currentPlayer.playOnHover || window.innerWidth <= 500 ) ) {
                    currentPlayer.playVideo();
                }
            }
        },
        pausePlayers : function(playerWrapper) {
            var playerWrapper = playerWrapper ? playerWrapper : null;
            if ( playerWrapper == null ) {
                for ( var i = 0; i < this.players.length; i++ ) {
                    if ( this.players[i].hasPlayerBeenCreated ) {
                        this.players[i].pauseVideo();
                    }
                }
            } else {
                for ( var i = 0; i < this.players.length; i++ ) {
                    var currentPlayer = this.players[i];
                    if ( playerWrapper.id == currentPlayer.playerWrapperId ) {
                        currentPlayer.pauseVideo();
                    }
                }
            }
        },
        init : function() {
            requestAnimationFrame(function() {
                var playerElements = document.querySelectorAll(this.PLAYER_SELECTOR);
                var needsYoutubeApi = false;
                for ( var i = 0; i < playerElements.length; i++ ) {
                    var playerElement = playerElements[i];
                    var type = playerElement.hasAttribute('data-video-id') ? "youtube" : "video";
                    if ( type == "youtube" ) {
                        needsYoutubeApi = true;
                    }
                }
                if ( needsYoutubeApi && !this.hasLoadedYoutubeApi ) {
                    this.loadYoutubeApi();
                }
                if ( !needsYoutubeApi ) {
                    this.initializePlayers();
                }
            }.bind(this));
        }
    }

    window.pd.video = video;

    // window.addEventListener('load', function() {
    document.addEventListener('DOMContentLoaded', function() {
        window.pd.video.init();
    });

    


})();